import BusinessTripTicketDetail from './BusinessTripTicketDetail';

export default BusinessTripTicketDetail;
